import { useState } from 'react';
import { getReport } from '../services/api';

interface ControlsBarProps {
  totalProducts: number;
}

export function ControlsBar({ totalProducts }: ControlsBarProps) {
  const [loadingReport, setLoadingReport] = useState(false);

  const handleShowReport = async () => {
    setLoadingReport(true);
    try {
      const html = await getReport();
      const reportWindow = window.open('', '_blank');
      if (!reportWindow) {
        alert('Le navigateur a bloqué l\'ouverture de la fenêtre. Autorisez les pop-ups pour ce site.');
        return;
      }
      reportWindow.document.open();
      reportWindow.document.write(html);
      reportWindow.document.close();
    } catch (error) {
      console.error('Failed to load report:', error);
      alert('Erreur lors du chargement du rapport');
    } finally {
      setLoadingReport(false);
    }
  };

  return (
    <footer className="bg-gray-800 border-t border-gray-700 p-4">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="text-gray-400 text-sm">
          {totalProducts} produit{totalProducts > 1 ? 's' : ''} suivi{totalProducts > 1 ? 's' : ''}
        </div>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={handleShowReport}
            disabled={loadingReport}
            className="px-4 py-2 bg-orange-600 hover:bg-orange-500 disabled:bg-orange-400 text-white font-medium rounded-lg transition-colors flex items-center gap-2"
          >
            {loadingReport ? '⏳ Génération...' : '📄 Rapport HTML'}
          </button>
        </div>
      </div>
    </footer>
  );
}